<template>
    <div>
        <div id="registerOnly" @click="changeStatus" v-if="loginState">
            <div class="frame" @click.stop>
                <div class="head">
                <img src="/static/logo.png" style="opacity:0"/>
                <span class="zh-remove" @click="changeStatus"></span>
                </div>
                <div class="content">
                <input
                    type="text"
                    class="phone"
                    placeholder="请输入您的手机号码"
                    v-model="phone"
                    @focus="codes=false"
                />
                <p></p>
                <input
                    type="text"
                    class="code"
                    placeholder="请输入手机验证码"
                    v-model="code"
                    @keyup.enter="_regist"
                />
                <button class="buttonCode" @click="_sendSMS" ref="code">{{seconds}}</button>
                <p>{{message}}</p>
                <button @click="_regist()">下一步</button>
                </div>
            </div>
            </div>
            <div id="registerOnly" @click="nameAndId=false" v-if="nameAndId">
            <div class="frame" @click.stop  style="height:370px">
                <div class="head">
                <img src="/static/logo.png" style="opacity:0"/>
                <span class="zh-remove" @click="nameAndId=false"></span>
                </div>
                <div class="content">
                <input
                    type="text"
                    class="phone"
                    placeholder="请输入您的真实姓名"
                    v-model="name"
                    @focus="codes=false"
                />
                <p></p>
                <input
                    type="text"
                    class="phone"
                    placeholder="请输入您的身份证号码"
                    v-model="id"
                    @keyup.enter="_updateRegistNameAndId"
                />
                <p></p>
                <input
                    type="text"
                    class="phone"
                    placeholder="请输入您的单位全称"
                    v-model="company"
                    @keyup.enter="_updateRegistNameAndId"
                />
                <p>{{message}}</p>
                <button @click="_updateRegistNameAndId()">下一步</button>
                </div>
            </div>
            </div>
            <div id="registerOnly" v-if="payTip">
            <div class="frame" @click.stop>
                <div class="head">
                <img src="/static/logo.png" style="opacity:0"/>
                <span class="zh-remove" @click="payTip=false" v-if="payStatus==2"></span>
                </div>
                <div class="content" v-if="payStatus==0">
                <!-- <p style="margin-bottom:10px">请选择支付金额</p> -->
                <span @click="selectPay=630" :class="{selectPay:selectPay==630}">630元</span>
                <!-- <span @click="selectPay=200" :class="{selectPay:selectPay==200}">200元</span> -->
                <button @click="_payTip()">立即支付</button>
                </div>
                <div class="content" v-if="payStatus==1">
                <p style="margin-bottom:60px;margin-top:20px;font-size:16px">请在新打开的页面完成支付后，点击下方“已完成”按钮，然后点击右上角登录按钮登录并完成后续操作。</p>
                <button @click="payTip=false">已完成</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
  sendSMS,
  phoneRegist,
  updateRegistNameAndId,
  baseURL,
  checkPayStatus
} from "@/assets/js/axios.js";
export default {
  name: "register",
  data() {
    return {
      register: false,
      IM: false,
      phone: "",
      code: "",
    //   loginState: false,
      nameAndId: false,
      payTip: false,
      payStatus: 0,
      message: "",
      seconds: "发送验证码",
      name: "",
      id: "",
      company: "",
      timer: "",
      selectPay: 630
    };
  },
  props:['loginState'],
  methods: {
    IMFun() {
      this.$confirm("关于集成电路继续教育相关问题（包含如何注册以及注册后的全部问题），请致电18610269133解决，在线客服不回答这类问题，谢谢。", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "退出"
      }).then(() => {
        this.$confirm("请再次确定所提问题与继续教育无关", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(() => {
          // <!--更改客服的qq号码20220308byfgq-->
          window.open("http://wpa.qq.com/msgrd?v=3&uin=47242304&site=qq&menu=yes", "_blank")
        }).catch(() => {

        });
      }).catch(() => {
      });
    },
    changeStatus(){
        this.$emit('update:loginState',false);
    },
    _payTip() {
      window.open(baseURL + "/pay/recharge?amount=" + this.selectPay, "_blank");
      this.payStatus = 1;
    },
    _updateRegistNameAndId() {
      if (!this.name) {
        this.message = "请输入您的真实姓名";
        return;
      }
      if (!this.id) {
        this.message = "请输入您的身份证号码";
        return;
      }
      if (!this.company) {
        this.message = "请输入您的单位全称";
        return;
      }
      updateRegistNameAndId(this.name, this.id, this.company).then(data => {
        if (parseInt(data.code) === 1) {
          this.nameAndId = false;
          this.payTip = true;
          this.payStatus = 0;
        } else {
          this.message = data.msg || "未知错误请重试";
        }
      });
    },
    _sendSMS() {
      if (this.phone) {
        if (this.seconds === "发送验证码" || this.seconds === "重新发送") {
          this.seconds = "60s";
          let that = this;
          this.$refs.code.style.background = "#ddd";
          let seconds = setInterval(() => {
            let x = parseInt(that.seconds);
            that.seconds = --x + "s";
            if (that.seconds === "0s") {
              that.seconds = "重新发送";
              clearInterval(seconds);
              this.$refs.code.style.background = "#109eff";
            }
          }, 1000);
          sendSMS(this.phone).then(data => {
            if (parseInt(data.code) !== 1) {
              this.message = data.msg || "未知错误，请重试";
              that.seconds = "重新发送";
              clearInterval(seconds);
              this.$refs.code.style.background = "#109eff";
            }
          });
        }
      } else {
        this.message = "请输入您的手机号码";
      }
    },
    _regist() {
      if (!this.phone) {
        this.message = "请输入您的手机号码";
        return;
      }
      if (!this.code) {
        this.message = "请输入手机验证码";
        return;
      }
      phoneRegist(this.phone, this.code).then(data => {
        if (parseInt(data.code) === 1) {
        //   this.loginState = false;
          this.$emit('update:loginState',false);
          this.nameAndId = true;
        } else {
          this.message = data.msg || "未知错误请重试";
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/modules/regiter.vue